var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forgotten-password page-background"},[_c('h1',[_vm._v("Fejlesztés alatt")])])}]

export { render, staticRenderFns }